module.exports = {"370921001":"文庙街道","370921002":"八仙桥街道","370921101":"泗店镇","370921102":"东疏镇","370921103":"伏山镇","370921105":"堽城镇","370921107":"蒋集镇","370921109":"磁窑镇","370921110":"华丰镇","370921111":"葛石镇","370921112":"东庄镇","370921113":"鹤山镇","370921206":"乡饮乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370921.json
// module id = 1439
// module chunks = 0